import { render, staticRenderFns } from "./UploadFileButton.vue?vue&type=template&id=248ea1ae&"
import script from "./UploadFileButton.vue?vue&type=script&lang=js&"
export * from "./UploadFileButton.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileButton.vue?vue&type=style&index=0&id=248ea1ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports